const FACE_RELATIONS = {
  me: "Me",
  partner: "Partner",
  mom: "Mom",
  father: "Dad",
  family: "Family",
  friend: "Friend",
};

const RELATIONS_WITH_ANNIVERSARY = {
  partner: "Partner",
};

const UNIQUE_FACE_RELATIONS = {
  me: "Me",
  partner: "Partner",
};

const UNIQUE_RELATIONS_KEYS = ["me", "partner"];

Object.freeze(FACE_RELATIONS);
Object.freeze(RELATIONS_WITH_ANNIVERSARY);
Object.freeze(UNIQUE_FACE_RELATIONS);

export { FACE_RELATIONS, RELATIONS_WITH_ANNIVERSARY, UNIQUE_RELATIONS_KEYS, UNIQUE_FACE_RELATIONS };
